import { useEffect, useRef, useState } from 'react';

const SECTIONS = [
  ['client', 'Client Info'], ['paperwork', 'Onboarding'], ['preauth', 'Pre-Authorization'],
  ['evaluation', 'Evaluation'], ['therapy', 'Therapy'], ['hold', 'Status'], ['discharge', 'Discharge'],
];

// Sticky tab row that jumps to each [data-section] inside the scrolling dialog.
export const ClientSectionTabs = ({ showDischarge, focus }) => {
  const ref = useRef(null);
  const [active, setActive] = useState('client');
  const lock = useRef(0);
  const items = SECTIONS.filter(([k]) => k !== 'discharge' || showDischarge);
  const box = () => ref.current?.closest('[data-testid="client-form-dialog"]');

  useEffect(() => {
    if (!focus) return;
    lock.current = Date.now() + 1500;
    setActive(focus);
  }, [focus]);

  useEffect(() => {
    const c = box();
    if (!c) return undefined;
    const onScroll = () => {
      if (Date.now() < lock.current) return;
      const top = c.getBoundingClientRect().top + Math.max((ref.current?.offsetHeight || 0) + 24, 130);
      let cur = 'client';
      c.querySelectorAll('[data-section]').forEach((el) => {
        if (el.getBoundingClientRect().top <= top) cur = el.dataset.section;
      });
      if (c.scrollTop + c.clientHeight >= c.scrollHeight - 4) {
        const all = c.querySelectorAll('[data-section]');
        if (all.length) cur = all[all.length - 1].dataset.section;
      }
      setActive(cur);
    };
    c.addEventListener('scroll', onScroll, { passive: true });
    return () => c.removeEventListener('scroll', onScroll);
  }, []);

  const jump = (key) => {
    const c = box();
    const el = c?.querySelector(`[data-section="${key}"]`);
    if (!c || !el) return;
    const y = el.getBoundingClientRect().top - c.getBoundingClientRect().top + c.scrollTop - (ref.current?.offsetHeight || 0) - 8;
    lock.current = Date.now() + 900;
    c.scrollTo({ top: y, behavior: 'smooth' });
    setActive(key);
  };

  return (
    <div ref={ref} className="sticky -top-6 z-20 -mx-6 px-6 py-3 bg-white/95 backdrop-blur border-b border-[#E8E5EC] flex flex-wrap gap-1.5" data-testid="client-section-tabs">
      {items.map(([k, label]) => (
        <button key={k} type="button" onClick={() => jump(k)} data-testid={`client-tab-${k}`}
          className={`px-3 py-1 rounded-full text-[12px] border transition-colors ${active === k
            ? 'bg-[#685B72] text-white border-[#685B72]'
            : 'bg-white text-[#685B72] border-[#E8E5EC] hover:bg-[#F1EDF5]'}`}>
          {label}
        </button>
      ))}
    </div>
  );
};

export default ClientSectionTabs;
